import {Component, OnInit, Input, ViewChild} from '@angular/core';
import { Pageable, Page } from 'src/app/model/rest/base';
import {ManagerColV3RestService} from "../../services/rest/v3/manager-col-v3-rest.service";
import {StudentBundleExtendComponent} from "../student-bundle-extend/student-bundle-extend.component";
import * as LessonsV3 from '../../model/v3/lessons';
import {CourseProductNameMapper} from '../../services/utils/v3/course-product-name-mapper';


@Component({
    selector: 'app-student-purchase-history',
    templateUrl: './student-purchase-history.component.html',
    styleUrls: ['./student-purchase-history.component.css'],
    standalone: false
})
export class StudentPurchaseHistoryComponent implements OnInit {
  _studentId: number;
  private pageable: Pageable;
  results: LessonsV3.LessonBundle[];
  lastPage: Page<LessonsV3.LessonBundle>;
  hasNext = false;
  _schoolId: number;
  @ViewChild('bundleExtendComponent')
  bundleExtendComponent: StudentBundleExtendComponent

  @Input()
  set studentId(studentId: number) {
    this._studentId = studentId;
  }

  @Input()
  set schoolId(schoolId: number) {
    this._schoolId = schoolId;
  }

  constructor(
    private managerRest: ManagerColV3RestService
  ) {}

  refresh() {
    this.results = [];
    this.loadThePage();
  }

  initDataLoading(): any {
    if (this._studentId == null) { return; }
    this.clear();
    this.pageable = Pageable.of(0, 10 , ['date,desc']);
    this.loadThePage();
  }

  loadThePage(): any {
    if (!this._schoolId) return;
    this.managerRest.findStudentLessonBundles(this._schoolId, this._studentId, null, null, this.pageable)
      .subscribe( page => this.handleResultPage(page));
  }

  handleResultPage(page: Page<LessonsV3.LessonBundle>): void {
    this.lastPage = page;
    this.results = this.results.concat(page.content);
    this.hasNext = !page.last;
  }

  next() {
    if (!this.hasNext || !this.pageable) { return; }
    this.pageable = this.pageable.next();
    this.loadThePage();
  }

  clear(): any {
    this.pageable = null;
    this.results = [];
    this.hasNext = false;
    this.lastPage = null;
  }

  ngOnInit() {
    this.initDataLoading();
  }

  changeExpiryDate(bundle: LessonsV3.LessonBundle) {
    this.bundleExtendComponent.openFor(bundle)
  }

  getBundleProductName(bundle: LessonsV3.LessonBundle): string {
    return CourseProductNameMapper.map(bundle?.product?.code);
  }
}
